module.exports = __webpack_public_path__ + "static/img/avatar-woman.adfb8af2.png";